import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import swal from "sweetalert";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload"
import Select from "react-select";
import { Progress } from "reactstrap"; 
const AddInvestment = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [inputsActivities, setInputsActivities] = useState({});
    const [inputsTeam, setInputsTeam] = useState({});
    const [documents, setDocuments] = useState({});
    const [view, setView] = useState(false);    
    const [viewActivities, setViewActivities] = useState(false);   
    
    const [viewDocuments, setViewDocuments] = useState(false); 
    const [viewTeam, setViewTeam] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Add Investments"); 
    const [allActivities,setAllActivities] = useState([]);
    
    const [allDocuments,setAllDocuments] = useState([]);
    const [allTeams,setAllTeams] = useState([]);  
    const [documentTypes, setdocumentTypes] = useState([]); 
    const [activeTab, setActiveTab] = useState('Campaign');
    const [RowData, setRowData] = useState([]);

    const [selectedFile, setselectedFile] = useState("");
    const [loaded, setloaded] = useState("");
    const [message, setmessage] = useState("");
    const url = "api/investment"; 

    const convertTimestampToDate=(timeStamp)=>{ 
        return new Date(timeStamp).toLocaleDateString('en-US');        
    }
    const maxSelectFile = (event) => {
        let files = event.target.files; // create file object
        if (files.length > 1) {
          const msg = "Only One file can be uploaded at a time";
          event.target.value = null;
          setmessage(msg);
    
          return false;
        }
        return true;
      };
    const onChangeHandler = (event) => {
        //for multiple files
        var files = event.target.files;
        if (maxSelectFile(event)) {
          setselectedFile(files);
          setloaded(0);
        }
      };
      const onClickHandler = (event) => {
        event.preventDefault();
        if (selectedFile) {
          const data = new FormData();
          for (var x = 0; x < selectedFile.length; x++) {
            data.append("file", selectedFile[x]);
          }
          Upload.post("/api/upload/files", data, {
            // receive two parameter endpoint url ,form data
            onUploadProgress: (ProgressEvent) => {
              setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
            },
          })
            .then((res) => {
              if (res.status == "200" && res.data.resultCode=="00") {
                setmessage("Uploaded successfully");
                setDocuments((documents) => ({ ...documents, path: res.data.data }));
              }else{
                setmessage("upload fail");
              }
            })
            .catch((err) => {
              setmessage("upload fail");
            });
        } else {
          setmessage("Select a file to upload");
        }
      };

   
 
      const handleSelectDocumentsChange = (UserGroup, actionMeta) => {
        setDocuments((documents) => ({ ...documents, [actionMeta.name]: UserGroup.value }));
      }; 
      const fetchACtivities = async (investmentId) => {
        try {
            Api.get("api/activities/findByInvestmentId?investmentId="+investmentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllActivities(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchDocuments = async (investmentId) => {
        try {
            Api.get("api/documents/getByInvestmentId?investmentId="+investmentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllDocuments(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchteam = async (investmentId) => {
        try {
            Api.get("api/teams/findByInvestmentId?investmentId="+investmentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllTeams(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    }; 
   
    const fetchDocumentTypes = async () => {
        try {
            Api.get("api/docType/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.docType.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setdocumentTypes((documentTypes) => [ ...documentTypes, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const MoreActions = (props) => {
        return (
          <span>
            <a
              class="btn btn-secondary btn-sm dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              More Actions&nbsp;&nbsp;
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </a>
    
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleView(props.selecteditem, e)}
              >
                View
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleEdit(props.selecteditem, e)}
              >
                Edit
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => HandleDelete(props.selecteditem, e)}
              >
                Delete
              </a>
    
    
            </div>
          </span>
        );
      };
    const setIncidentsdata = async (data) => {       
        const rows = data?.investment || [];                 
                
                rows.forEach((k) => {
                    const Rowdata = { 
                        id:k.id,
                        title: k.title, 
                        description: k.description,                      
                        Actions: <MoreActions selecteditem={k} />,
                    }; 
                    setRowData((inputs) => [ ...inputs, Rowdata ]);
                        
                });
            
    }
    const FetchAll = async () => { 
        setRowData([]);
        try {
            Api.get(url + "/getAll?page=0&size=10")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setIncidentsdata(data); 
                const totalPages = data.totalPages;   
                for (let i = 0; i < totalPages; i++) {  
                    let nextPage=parseFloat(i) + parseFloat(1) ;       
                    Api.get(url + "/getAll?page="+nextPage+"&size=10")
                    .then(function (response) {                        
                      if (response.status=== 200) {
                        const data =response.data;
                        setIncidentsdata(data); 
                      }
                    })
                    .catch(function (error) {
                    })
                    .then(function () {
                      // always executed
                    }) 
                }
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })

            

            
        } catch (error) {
            console.error("Error fetching securityIncidents:", error);
        }
    }; 
    useEffect(() => {
        FetchAll();    
        fetchDocumentTypes();  
    }, []);

  

    const handleOpenModal = () => {
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    const handleActivitiesInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputsActivities((inputsActivities) => ({ ...inputsActivities, [name]: value }));
    };
    const handleTeamInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputsTeam((inputsTeam) => ({ ...inputsTeam, [name]: value }));
    };
    const handleDocumentsInputChange= (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setDocuments((documents) => ({ ...documents, [name]: value }));
    };
    const handleEdit = (k) => {
        setInputs(k);
        if (k.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };
 
    const handleView = (k) => {
        setInputs(k);         
        setInputsActivities((inputsActivities) => ({ ...inputsActivities, ["investmentId"]: k.id }));
        setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["investmentId"]:k.id}));
        setDocuments((documents) => ({ ...documents,["investmentId"]: k.id }));
        if (k.id) {
            fetchACtivities(k.id);
            fetchDocuments(k.id);
            fetchteam(k.id);
            setView(true);
            setViewTeam(true);
            setViewActivities(true)
            setViewDocuments(true)
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };

    const HandleSave = (inputs,url,menu) => {
        useSave(url+"/create", inputs,menu);
        setTimeout(function () {
            FetchAll();
        }, 4000);
    };

    const HandleUpdate = (inputs,url) => {
        useUpdate(url+"/update" , inputs);
        setTimeout(function () {
            FetchAll();
        }, 4000);
        
    };
    const useSave = (url = ``, inputs = {},menu=``, config = {}) => {
         
          let data;
          let headers;
      
          if (inputs instanceof FormData) {
            data = inputs;
            headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
          } else {
            data = JSON.stringify(inputs);
            headers = { 'Content-Type': 'application/json', ...config.headers };
          }      
          Api.post(url, data, { headers })
            .then((response) => {
              if (response.data.resultCode === "00") {
                if(menu==="Investment"){
                    var result = JSON.parse(response.data.data); 
                    setInputs((inputs) => ({ ...inputs, ["id"]: result.id }));
                    setInputsActivities((inputsActivities) => ({ ...inputsActivities, ["investmentId"]: result.id }));
                     setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["investmentId"]:result.id}));
                    setDocuments((documents) => ({ ...documents,["investmentId"]: result.id }));
                }
               
                swal("", "saved", "success"); 
              } else {
                swal("", response.data.description, "error"); 
              }
            })
            .catch((error) => {
              swal("", "Failed", "error"); 
            });
        
      };
    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate(inputs,url);
        } else {
            HandleSave(inputs,url,"Investment");
        }
    };
    const HandleSubmitDocuments = (event) => {
        event.preventDefault(); 
        if(!documents.investmentId || documents.investmentId == "undefined"){
            alert("Add or select campaign first")
            return;
        } 
        if (update) {
            HandleUpdate(documents,"api/documents");
        } else {
            HandleSave(documents,"api/documents","Documents");
        }
        setTimeout(function () {
            fetchDocuments(inputs.id)
        }, 4000);
       
    };
    const handleSubmitTeam = (event) => {


        event.preventDefault(); 
        if(!inputsTeam.investmentId || inputsTeam.investmentId == "undefined"){
            alert("Add or select investment first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsTeam,"api/teams");
        } else {
            HandleSave(inputsTeam,"api/teams","Team");
        }
        setTimeout(function () {
            fetchteam(inputs.id)
        }, 4000);
        
    };
    
    const HandleSubmitActivities = (event) => {

        event.preventDefault(); 
        if(!inputsActivities.investmentId || inputsActivities.investmentId == "undefined"){
            alert("Add or select investment first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsActivities,"api/activities");
        } else {
            HandleSave(inputsActivities,"api/activities","Activities");
        }
        setTimeout(function () {
            fetchACtivities(inputs.id)
        }, 4000);
       
    };

    const CallDeleteHook = (id) => {
        useDelete(url + "/delete?id=" + id);
        setTimeout(function () {
            FetchAll();
        }, 4000);
        
    };

    const HandleDelete = (k) => {
        setInputs(k);
        if (k.id) {
            CallDeleteHook(k.id);
        } else {
            alert("Select a record to delete");
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 16);
    };

    const ColumnData = [
        { label: "Title", field: "title", sort: "asc" },
        
        { label: "Description", field: "description", sort: "asc" },
        {
            label: "Actions",
            field: "Actions",
            sort: "asc",
          }

    ];
   

   

    const ActionsBtn = () => {
        return (
            <div>
                {/* {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null} */}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Investment</li>
            </ol>
            <h1 className="page-header mb-3">Investment</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New Investment &nbsp;
                            </button>
                        ) : null}
                         
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="80%" height="90%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 font-weight-bold text-blue">
                                Investment
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />
                                <div className="tab-content" id="myTabContent">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Campaign' ? 'active' : ''}`} id="Campaign-tab" onClick={() => setActiveTab('Campaign')} role="tab" aria-selected={activeTab === 'Campaign'}>Investment</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Activities' ? 'active' : ''}`} id="Activities-tab" onClick={() => setActiveTab('Activities')} role="tab" aria-selected={activeTab === 'Activities'}>Investment Activities</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Team' ? 'active' : ''}`} id="Team-tab" onClick={() => setActiveTab('Team')} role="tab" aria-selected={activeTab === 'Team'}>Investment Team</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Documents' ? 'active' : ''}`} id="Documents-tab" onClick={() => setActiveTab('Documents')} role="tab" aria-selected={activeTab === 'Documents'}>Documents</a>
                                            </li> 
                                </ul>
                                <div className={`tab-pane fade ${activeTab === 'Campaign' ? 'show active' : ''}`} id="Campaign-tab-pane" role="tabpanel" aria-labelledby="Campaign-tab">
                                <h3>Investment details</h3>
                                   {view ? (
                                    <div>
                                            <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Title:</td>
                                                    <td>{inputs.title}</td>
                                                </tr> 
                                                 
                                                <tr>
                                                    <td className="font-weight-bold">Description:</td>
                                                    <td>{inputs.description}</td>
                                                </tr>                                               
                                                 
                                                <tr>
                                                    <td className="font-weight-bold">Created At:</td>
                                                    <td>{inputs.createdAt ? formatDate(inputs.createdAt) : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created By:</td>
                                                    <td>{inputs.createdBy}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                   Title
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title"
                                                        required
                                                        value={inputs.title || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div> 
                                        </div> 
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={inputs.description || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>
                                                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div> 
                                <div className={`tab-pane fade ${activeTab === 'Activities' ? 'show active' : ''}`} id="Activities-tab-pane" role="tabpanel" aria-labelledby="Activities-tab">
                                <h3>Activities</h3>
                                   {viewActivities ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewActivities(false)}}>Add Activity</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                    <th>Name</th>
                                                    <th>Description</th>
                                                    <th>Planned StartDate</th>
                                                    <th>Planned EndDate</th>
                                                    <th>Actual StartDate</th>
                                                    <th>Actual EndDate</th>
                                                    <th>Planned Budget</th>
                                                    <th>Actual Budget</th>
                                                    <th>Status</th>
                                                </tr>
                                            <tbody>
                                            

                                            {allActivities.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                    <td>{d.name}</td>
                                                    <td>{d.description}</td>
                                                    <td>{d.plannedStartDate?convertTimestampToDate(d.plannedStartDate):"N/A"}</td>
                                                    <td>{d.plannedEndDate?convertTimestampToDate(d.plannedEndDate):"N/A"}</td>
                                                    <td>{d.actualStartDate?convertTimestampToDate(d.actualStartDate):"N/A"}</td>
                                                    <td>{d.actualEndDate?convertTimestampToDate(d.actualEndDate):"N/A"}</td>
                                                    <td>{d.plannedBudget}</td>
                                                    <td>{d.actualBudget}</td>
                                                    <td>{d.status}</td>
                                                </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmitActivities}>
                                        <button className="btn-warning" onClick={()=>{setViewActivities(true)}}>Back</button>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                    Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={inputsActivities.name || ""}
                                                        onChange={handleActivitiesInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                    Status
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        required
                                                        value={inputsActivities.status || ""}
                                                        onChange={handleActivitiesInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                  
                                   
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={inputsActivities.description || ""}
                                                        onChange={handleActivitiesInputChange}
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>
                                        <div className="row">
                                     
                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="categoryId" className="font-weight-bold">
                                             Planned Start Date
                                             </label>
                                             <input
                                                 type="date"
                                                 className="form-control"
                                                 name="plannedStartDate"
                                                 required
                                                 value={inputsActivities.plannedStartDate || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="timeOfIncident" className="font-weight-bold">
                                             Planned End Date
                                             </label>
                                             <input
                                                 type="date"
                                                 className="form-control"
                                                 name="plannedEndDate"
                                                 required
                                                 value={inputsActivities.plannedEndDate || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                 </div>  
                                 <div className="row">
                                     
                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="categoryId" className="font-weight-bold">
                                             actual Start Date
                                             </label>
                                             <input
                                                 type="date"
                                                 className="form-control"
                                                 name="actualStartDate"
                                                 required
                                                 value={inputsActivities.actualStartDate || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="timeOfIncident" className="font-weight-bold">
                                             Actual End Date
                                             </label>
                                             <input
                                                 type="date"
                                                 className="form-control"
                                                 name="actualEndDate"
                                                 required
                                                 value={inputsActivities.actualEndDate || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                 </div>  
                                 <div className="row">
                                     
                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="plannedBudget" className="font-weight-bold">
                                             Planned Budget
                                             </label>
                                             <input
                                                 type="number"
                                                 className="form-control"
                                                 name="plannedBudget"
                                                 required
                                                 value={inputsActivities.plannedBudget || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                     <div className="col-sm">
                                         <div className="form-group">
                                             <label htmlFor="timeOfIncident" className="font-weight-bold">
                                             Actual Budget
                                             </label>
                                             <input
                                                 type="number"
                                                 className="form-control"
                                                 name="actualBudget"
                                                 required
                                                 value={inputsActivities.actualBudget || ""}
                                                 onChange={handleActivitiesInputChange}
                                             />
                                         </div>
                                     </div>

                                 </div>  
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                                <div className={`tab-pane fade ${activeTab === 'Team' ? 'show active' : ''}`} id="Team-tab-pane" role="tabpanel" aria-labelledby="Team-tab">
                                <h3>Team</h3>
                                   {viewTeam ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewTeam(false)}}>Add Team Member</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                    <th>Name </th>
                                                    
                                                </tr>
                                            <tbody>
                                            

                                            {allTeams.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                    <td>{d.name}</td>
                                                   </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={handleSubmitTeam}>

                                        <button className="btn-warning" onClick={()=>{setViewTeam(true)}}>Back</button>
                                        <div className="row"> 
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={inputsTeam.name || ""}
                                                        onChange={handleTeamInputChange}
                                                    />
                                                </div>
                                            </div>                                        
                                        </div>
                                   
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                                <div className={`tab-pane fade ${activeTab === 'Documents' ? 'show active' : ''}`} id="Documents-tab-pane" role="tabpanel" aria-labelledby="Documents-tab">
                                <h3>Documents</h3>
                                   {viewDocuments ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewDocuments(false)}}>Add Document</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                <th>Type</th>
                                                    <th>Name</th>
                                                    <th>Description </th>
                                                    <th>View </th>
                                                </tr>
                                            <tbody>
                                            

                                            {allDocuments.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                     <td>{d.docType.name}</td>
                                                     <td>{d.name}</td>
                                                    <td>{d.description}</td>
                                                    <td><a href={ process.env.REACT_APP_BASE_URL +"api/upload/files/"+d.path} target="_blank"> View </a></td>
                                                   </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmitDocuments}>
                                        <button className="btn-warning" onClick={()=>{setViewDocuments(true)}}>Back</button>
                                        <div className="row"> 
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Document Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={documents.name || ""}
                                                        onChange={handleDocumentsInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Document Type
                                                    </label>
                                                    <Select
                                                  name="typeId"
                                                value={documentTypes.filter(
                                                (option) =>
                                                  option.value ===
                                                documents.typeId
                                              )}
                                              onChange={
                                                handleSelectDocumentsChange
                                              }
                                              options={documentTypes}
                                            />
                                                </div>
                                            </div>
                                        </div>
                                  
                                       
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={documents.description || ""}
                                                        onChange={handleDocumentsInputChange}
                                                    />
                                                </div>
                                            </div>                                    
                                        </div>
                                        <div className="row">
                                        <div className="col-sm-12">
                                            <input
                                                type="file"
                                                className="form-control"
                                                name="file"
                                                onChange={onChangeHandler}
                                                accept=".xlsx, .xls, .csv"
                                            />
                                            </div>
                                            <br/>
                                            <div className="col-sm-12">
                                                <Progress
                                                max="100"
                                                color="success"
                                                value={loaded}
                                                >
                                                {Math.round(loaded, 2)}%
                                                </Progress>
                                                <button
                                                type="button"
                                                class="btn btn-success "
                                                onClick={onClickHandler}
                                                >
                                                Upload
                                                </button>
                                            </div>
                                            <p>{message}</p>
                                        </div>
                                          <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default AddInvestment;
